const sendResponse = {
  title: "Send response",
  fields: {
    status: "Response status",
    reason: "Reason",
    comment: "Comment",
  },
  placeholders: {
    status: "Select status",
    reason: "Select reason",
    comment: "Enter comment",
  },
  actions: {
    submit: "Send response",
    cancel: "Cancel",
  },
  statuses: {
    AB: "Received",
    IP: "In progress",
    UQ: "Clarification needed",
    CA: "Accepted with conditions",
    RE: "Rejected",
    AP: "Accepted",
    PD: "Paid",
  },
  reasons: {
    NON: "Non-compliant",
    REF: "Incorrect reference",
    LEG: "Legal issue",
    REC: "Receiver unknown",
    QUA: "Quality issue",
    DEL: "Delivery issue",
    PRI: "Price issue",
    QTY: "Quantity issue",
    ITM: "Item issue",
    PAY: "Payment issue",
    UNR: "Unrecognized invoice",
    FIN: "Financial issue",
    PPD: "Already paid",
    OTH: "Other",
  },
};

export default sendResponse;
